import en from './locale/en.json';

export default {
  en,
};
